import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useAuthContext } from '../../sections/auth';
import fcmService from '../../services/fcmService';

/**
 * FCMInitializer component
 * This component must be inside both Router and SnackbarProvider
 * to have access to useNavigate and useSnackbar hooks
 */
export default function FCMInitializer() {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    // Only set up the message listener when we have all the dependencies
    if (user?.id && navigate && enqueueSnackbar) {
      console.log('🔔 Setting up FCM message listener with navigation and snackbar');
      fcmService.setupMessageListener(navigate, enqueueSnackbar);
    }
  }, [user?.id, navigate, enqueueSnackbar]);

  // This component doesn't render anything
  return null;
}


